export const countriesFallback = [{ id: 'SE', name: 'Sverige' }];
